/** Internal type. DO NOT USE DIRECTLY. */
import { gql } from "@apollo/client"
import * as Apollo from "@apollo/client"

import * as Types from "../../types/__generated__/graphql"
import { ProcessFragmentDoc } from "../process/fragments.generated"

type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] }
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends " $fragmentName" | "__typename" ? T[P] : never
    }

const defaultOptions = {} as const
export type DuplicateEntityInput = {
  desiredId?: string | null
  id: string
  label?: string | null
  position?: number | null
  recursive: boolean
  source: JsonapiRelationshipData
  target?: JsonapiRelationshipData | null
}

export type JsonapiRelationshipData = {
  id: string
  type: string
}

export type DuplicateEntityMutationVariables = Exact<{
  input: Types.DuplicateEntityInput
}>

export type DuplicateEntityMutation = {
  __typename: "Mutation"
  process: {
    __typename: "Process"
    id: string
    copyId?: string | null
    createdAt?: string | null
    error?: string | null
    finished?: boolean | null
    originId?: string | null
    originType?: string | null
    targetId?: string | null
    targetType?: string | null
    updatedAt?: string | null
    options?: {
      __typename: "ProcessOptions"
      recursive?: boolean | null
    } | null
  }
}

export const DuplicateEntityDocument = gql`
  mutation DuplicateEntity($input: DuplicateEntityInput!) {
    process: duplicateEntity(input: $input)
      @rest(
        type: "Process"
        method: "POST"
        path: "/project-list/entity/duplicate"
        bodySerializer: "duplicateEntity"
      ) {
      ...Process
    }
  }
  ${ProcessFragmentDoc}
`
export type DuplicateEntityMutationFn = Apollo.MutationFunction<
  DuplicateEntityMutation,
  DuplicateEntityMutationVariables
>

/**
 * __useDuplicateEntityMutation__
 *
 * To run a mutation, you first call `useDuplicateEntityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDuplicateEntityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [duplicateEntityMutation, { data, loading, error }] = useDuplicateEntityMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDuplicateEntityMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DuplicateEntityMutation,
    DuplicateEntityMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    DuplicateEntityMutation,
    DuplicateEntityMutationVariables
  >(DuplicateEntityDocument, options)
}
export type DuplicateEntityMutationHookResult = ReturnType<
  typeof useDuplicateEntityMutation
>
export type DuplicateEntityMutationResult =
  Apollo.MutationResult<DuplicateEntityMutation>
export type DuplicateEntityMutationOptions = Apollo.BaseMutationOptions<
  DuplicateEntityMutation,
  DuplicateEntityMutationVariables
>
